var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from "react";
import useAdminStore from "@/services/store/useAdminStore";
import api from "@/api/admin";
import translate from "@/utilities/i18n/getTranslate";
import { k } from "@/utilities/i18n";
import useErrorHandler from "@/utilities/hooks/useErrorHandler";
export var useAuthToggle = function () {
    var _a, _b, _c;
    var _d = __read(useState(false), 2), isLegacyPopupOpen = _d[0], setIsLegacyPopupOpen = _d[1];
    var _e = __read(useState(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    var handleError = useErrorHandler();
    var _f = useAdminStore(), adminNotification = _f.adminNotification, adminStore = _f.adminStore;
    var bearerTokenAuthDisabled = (_c = (_b = (_a = adminStore.currentPartner) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.bearerTokenAuthDisabled) !== null && _c !== void 0 ? _c : false;
    var replacePlaceholderString = function (text, newValue) {
        return text.replace("<ACTION>", newValue ? "disabled" : "enabled");
    };
    var toggleBearerTokenAuthDisabled = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newValue, response, meta, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = adminStore.currentPartner) === null || _a === void 0 ? void 0 : _a.id))
                        return [2 /*return*/];
                    newValue = !bearerTokenAuthDisabled;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    setIsLoading(true);
                    adminNotification.add({
                        message: translate(k.CH_savingLocalStorageLocation),
                        type: adminNotification.types.INFO,
                        id: 100,
                    });
                    return [4 /*yield*/, api.partners.patch.editAuthSettings({ partnerId: adminStore.currentPartner.id }, { bearerTokenAuthDisabled: newValue })];
                case 2:
                    response = _b.sent();
                    adminNotification.remove(100);
                    adminStore.setBearerTokenAuthDisabled(newValue);
                    meta = response.data.meta;
                    adminNotification.add({
                        message: (meta === null || meta === void 0 ? void 0 : meta.developer_message)
                            ? meta.developer_message
                            : replacePlaceholderString(translate(k.KEY_legacyToggleUpdate), newValue),
                        type: adminNotification.types.SUCCESS,
                    });
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _b.sent();
                    handleError(err_1, { message: translate(k.ERR_updatingLegacyTokenAuthentication) }, "Updating legacy token authentication failed");
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    setIsLegacyPopupOpen(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        isLegacyPopupOpen: isLegacyPopupOpen,
        setIsLegacyPopupOpen: setIsLegacyPopupOpen,
        toggleBearerTokenAuthDisabled: toggleBearerTokenAuthDisabled,
        bearerTokenAuthDisabled: bearerTokenAuthDisabled,
        isLoading: isLoading,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQXV0aFRvZ2dsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZUF1dGhUb2dnbGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQ2pDLE9BQU8sYUFBYSxNQUFNLGdDQUFnQyxDQUFDO0FBQzNELE9BQU8sR0FBRyxNQUFNLGFBQWEsQ0FBQztBQUM5QixPQUFPLFNBQVMsTUFBTSwrQkFBK0IsQ0FBQztBQUN0RCxPQUFPLEVBQUUsQ0FBQyxFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFDckMsT0FBTyxlQUFlLE1BQU0sbUNBQW1DLENBQUM7QUFFaEUsTUFBTSxDQUFDLElBQU0sYUFBYSxHQUFHOztJQUNyQixJQUFBLEtBQUEsT0FBNEMsUUFBUSxDQUFDLEtBQUssQ0FBQyxJQUFBLEVBQTFELGlCQUFpQixRQUFBLEVBQUUsb0JBQW9CLFFBQW1CLENBQUM7SUFDNUQsSUFBQSxLQUFBLE9BQTRCLFFBQVEsQ0FBQyxLQUFLLENBQUMsSUFBQSxFQUExQyxTQUFTLFFBQUEsRUFBRSxZQUFZLFFBQW1CLENBQUM7SUFDbEQsSUFBTSxXQUFXLEdBQUcsZUFBZSxFQUFFLENBQUM7SUFDaEMsSUFBQSxLQUFvQyxhQUFhLEVBQUUsRUFBakQsaUJBQWlCLHVCQUFBLEVBQUUsVUFBVSxnQkFBb0IsQ0FBQztJQUMxRCxJQUFNLHVCQUF1QixHQUMzQixNQUFBLE1BQUEsTUFBQSxVQUFVLENBQUMsY0FBYywwQ0FBRSxRQUFRLDBDQUFFLHVCQUF1QixtQ0FBSSxLQUFLLENBQUM7SUFFeEUsSUFBTSx3QkFBd0IsR0FBRyxVQUFDLElBQVksRUFBRSxRQUFpQjtRQUMvRCxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsVUFBVSxFQUFFLFFBQVEsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUNyRSxDQUFDLENBQUM7SUFFRixJQUFNLDZCQUE2QixHQUFHOzs7Ozs7b0JBQ3BDLElBQUksQ0FBQyxDQUFBLE1BQUEsVUFBVSxDQUFDLGNBQWMsMENBQUUsRUFBRSxDQUFBO3dCQUFFLHNCQUFPO29CQUNyQyxRQUFRLEdBQUcsQ0FBQyx1QkFBdUIsQ0FBQzs7OztvQkFHeEMsWUFBWSxDQUFDLElBQUksQ0FBQyxDQUFDO29CQUNuQixpQkFBaUIsQ0FBQyxHQUFHLENBQUM7d0JBQ3BCLE9BQU8sRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLDZCQUE2QixDQUFDO3dCQUNuRCxJQUFJLEVBQUUsaUJBQWlCLENBQUMsS0FBSyxDQUFDLElBQUk7d0JBQ2xDLEVBQUUsRUFBRSxHQUFHO3FCQUNSLENBQUMsQ0FBQztvQkFFYyxxQkFBTSxHQUFHLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxnQkFBZ0IsQ0FDeEQsRUFBRSxTQUFTLEVBQUUsVUFBVSxDQUFDLGNBQWMsQ0FBQyxFQUFFLEVBQUUsRUFDM0MsRUFBRSx1QkFBdUIsRUFBRSxRQUFRLEVBQUUsQ0FDdEMsRUFBQTs7b0JBSEssUUFBUSxHQUFHLFNBR2hCO29CQUVELGlCQUFpQixDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQztvQkFDOUIsVUFBVSxDQUFDLDBCQUEwQixDQUFDLFFBQVEsQ0FBQyxDQUFDO29CQUV4QyxJQUFJLEdBQUssUUFBUSxDQUFDLElBQUksS0FBbEIsQ0FBbUI7b0JBQy9CLGlCQUFpQixDQUFDLEdBQUcsQ0FBQzt3QkFDcEIsT0FBTyxFQUFFLENBQUEsSUFBSSxhQUFKLElBQUksdUJBQUosSUFBSSxDQUFFLGlCQUFpQjs0QkFDOUIsQ0FBQyxDQUFDLElBQUksQ0FBQyxpQkFBaUI7NEJBQ3hCLENBQUMsQ0FBQyx3QkFBd0IsQ0FDdEIsU0FBUyxDQUFDLENBQUMsQ0FBQyxzQkFBc0IsQ0FBQyxFQUNuQyxRQUFRLENBQ1Q7d0JBQ0wsSUFBSSxFQUFFLGlCQUFpQixDQUFDLEtBQUssQ0FBQyxPQUFPO3FCQUN0QyxDQUFDLENBQUM7Ozs7b0JBRUgsV0FBVyxDQUNULEtBQUcsRUFDSCxFQUFFLE9BQU8sRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLHFDQUFxQyxDQUFDLEVBQUUsRUFDL0QsNkNBQTZDLENBQzlDLENBQUM7OztvQkFFRixZQUFZLENBQUMsS0FBSyxDQUFDLENBQUM7b0JBQ3BCLG9CQUFvQixDQUFDLEtBQUssQ0FBQyxDQUFDOzs7OztTQUUvQixDQUFDO0lBRUYsT0FBTztRQUNMLGlCQUFpQixtQkFBQTtRQUNqQixvQkFBb0Isc0JBQUE7UUFDcEIsNkJBQTZCLCtCQUFBO1FBQzdCLHVCQUF1Qix5QkFBQTtRQUN2QixTQUFTLFdBQUE7S0FDVixDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=